/* TCGRealm theme behaviour (v2, 30 Sep 2026).
   No framework and no build step. Everything is progressive: with JS off the
   header links go to /cart and /search, forms post normally and nothing is
   hidden (reveal styles only apply under html.js). */
(function () {
  "use strict";

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var cfg = window.TCGR || { routes: { cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", predictive: "/search/suggest", search: "/search" }, money: "${{amount}}" };
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function money(cents) {
    var fmt = cfg.money || "${{amount}}";
    var n = (cents || 0) / 100;
    function withDelims(num, dec, thou, sep) {
      var parts = num.toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === "amount_no_decimals") return withDelims(n, 0, ",", ".");
      if (k === "amount_with_comma_separator") return withDelims(n, 2, ".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return withDelims(n, 0, ".", ",");
      return withDelims(n, 2, ",", ".");
    });
  }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }

  /* ------------------------------------------------ announcement rotator */
  (function () {
    var bar = $("[data-announce]");
    if (!bar) return;
    var msgs = $$(".announce__msg", bar);
    if (msgs.length < 2 || reduceMotion) return;
    var i = 0, timer;
    function next() {
      msgs[i].classList.remove("is-active");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
    }
    function start() { timer = setInterval(next, 4500); }
    bar.addEventListener("mouseenter", function () { clearInterval(timer); });
    bar.addEventListener("mouseleave", start);
    start();
  })();

  /* ------------------------------------------------------------- header */
  var header = $("[data-header]");
  (function () {
    if (!header) return;
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 8); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    var toggle = $("[data-search-toggle]", header);
    var input = $("[data-predictive-input]", header);
    if (toggle && input) {
      toggle.addEventListener("click", function () {
        var open = header.classList.toggle("is-search-open");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) setTimeout(function () { input.focus(); }, 30);
      });
    }
    /* "/" jumps to search, as on most catalogue sites */
    document.addEventListener("keydown", function (e) {
      if (e.key !== "/" || !input) return;
      var t = e.target.tagName;
      if (t === "INPUT" || t === "TEXTAREA" || t === "SELECT" || e.target.isContentEditable) return;
      e.preventDefault();
      header.classList.add("is-search-open");
      input.focus();
    });

    /* Mega menus: the chevron toggles for touch and keyboard; a mouse gets
       CSS hover. Opening one closes the others; Escape and outside clicks close. */
    var items = $$("[data-mega]", header);
    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove("is-open");
        var b = $("[data-mega-toggle]", it);
        if (b) b.setAttribute("aria-expanded", "false");
      });
    }
    items.forEach(function (it) {
      var btn = $("[data-mega-toggle]", it);
      if (!btn) return;
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = !it.classList.contains("is-open");
        closeAll(it);
        it.classList.toggle("is-open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
      /* Moving the mouse off an item that was opened by click closes it. */
      it.addEventListener("mouseleave", function () {
        if (finePointer && it.classList.contains("is-open")) { it.classList.remove("is-open"); btn.setAttribute("aria-expanded", "false"); }
      });
    });
    document.addEventListener("click", function (e) { if (!e.target.closest("[data-mega]")) closeAll(); });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var open = items.filter(function (it) { return it.classList.contains("is-open") || it.contains(document.activeElement); })[0];
      closeAll();
      /* A hover/focus-within panel ignores .is-open, so briefly suppress it. */
      header.classList.add("is-mega-closed");
      setTimeout(function () { header.classList.remove("is-mega-closed"); }, 350);
      if (open) { var l = $(".hdr__link", open); if (l) l.focus(); }
    });
  })();

  /* ------------------------------------------------------------ drawers */
  var lastFocus = null;
  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
  }
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("has-drawer");
    $$('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
    var panel = $(".drawer__panel", d);
    setTimeout(function () { (panel || d).focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d || !d.classList.contains("is-open")) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("has-drawer");
    $$('[data-drawer-open="' + d.getAttribute("data-drawer") + '"]').forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  /* Escape closes an open drawer wherever focus is -- after a cart line is
     removed its button (and the focus) is gone, so a listener on the drawer
     alone never hears the key. */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    $$("[data-drawer].is-open").forEach(closeDrawer);
  });
  $$("[data-drawer-open]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(b.getAttribute("data-drawer-open")); });
  });
  $$("[data-drawer]").forEach(function (d) {
    $$("[data-drawer-close]", d).forEach(function (c) { c.addEventListener("click", function () { closeDrawer(d); }); });
    d.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeDrawer(d); return; }
      if (e.key !== "Tab") return;
      var f = focusables(d);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  });

  /* --------------------------------------------------------------- cart */
  var cartDrawer = $('[data-drawer="cart"]');
  function setCounts(n) {
    $$("[data-cart-count]").forEach(function (c) {
      c.textContent = n;
      c.classList.toggle("is-empty", n === 0);
      c.classList.remove("is-bump");
      void c.offsetWidth; /* restart the animation */
      c.classList.add("is-bump");
      var link = c.closest("a");
      if (link) link.setAttribute("aria-label", "Cart, " + n + " item" + (n === 1 ? "" : "s"));
    });
    var dc = $("[data-cartd-count]");
    if (dc) dc.textContent = "(" + n + ")";
  }
  /* A line's real price. Shopify books the volume savings (and TREAT / JACKPOT codes) as a
     CART-level discount, so final_line_price is still the full price there; total_discount carries
     the line's share of every discount, i.e. what checkout charges for the line. */
  function linePrice(it) {
    var full = it.original_line_price || it.final_line_price;
    var paid = Math.min(it.final_line_price, full - (it.total_discount || 0));
    if (paid >= full) return '<span class="cartd__price">' + money(full) + "</span>";
    return '<span class="cartd__price cartd__price--off"><s>' + money(full) + "</s><b>" + money(paid) + "</b>" +
      '<small>You save ' + money(full - paid) + "</small></span>";
  }
  function renderCart(cart) {
    if (!cartDrawer) return;
    var box = $("[data-cartd-lines]", cartDrawer);
    var foot = $("[data-cartd-foot]", cartDrawer);
    var sub = $("[data-cartd-subtotal]", cartDrawer);
    setCounts(cart.item_count);
    if (!cart.item_count) {
      box.innerHTML = '<div class="cartd__empty"><p>Your cart is empty.</p><a class="btn btn--primary" href="/collections/all">Start shopping</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    var html = '<ul class="cartd__lines" role="list">';
    cart.items.forEach(function (it, idx) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "$1$2") + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=160" : "";
      var variant = it.variant_title && it.variant_title !== "Default Title" ? '<p class="cartd__variant">' + esc(it.variant_title) + "</p>" : "";
      html += '<li class="cartd__line" data-line="' + (idx + 1) + '" data-key="' + esc(it.key) + '" style="animation-delay:' + (reduceMotion ? 0 : idx * 50) + 'ms">' +
        (img ? '<a href="' + esc(it.url) + '"><img class="cartd__img" src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy"></a>' : '<span class="cartd__img"></span>') +
        '<div class="cartd__info"><a class="cartd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + "</a>" + variant +
        '<div class="cartd__row2"><div class="cartd__qty">' +
        '<button type="button" data-qty-change="-1" aria-label="Decrease quantity of ' + esc(it.product_title) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12h14"/></svg></button>' +
        '<span aria-live="polite">' + it.quantity + "</span>" +
        '<button type="button" data-qty-change="1" aria-label="Increase quantity of ' + esc(it.product_title) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div>' + linePrice(it) + "</div>" +
        '<button type="button" class="cartd__remove" data-remove>Remove</button></div></li>';
    });
    html += "</ul>";
    box.innerHTML = html;
    if (foot) foot.hidden = false;
    if (sub) sub.textContent = money(cart.total_price);
    /* Items total, each discount Shopify actually applied, then the subtotal it charges. */
    var discBox = $("[data-cartd-discounts]", cartDrawer);
    var saved = $("[data-cartd-saved]", cartDrawer);
    var rows = [], at = {};
    /* /cart.js lists these flat ({title, total_allocated_amount}); /cart/change.js wraps them
       ({amount, discount_application: {title, ...}}). Read both. */
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      var app = a.discount_application || a;
      var amt = a.total_allocated_amount != null ? a.total_allocated_amount : (a.amount != null ? a.amount : app.total_allocated_amount);
      if (app.title && amt) rows.push([app.title, amt]);
    });
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var t = al.discount_application.title;
        if (at[t] == null) { at[t] = rows.length; rows.push([t, 0]); }
        rows[at[t]][1] += al.amount;
      });
    });
    var off = cart.total_discount || rows.reduce(function (s, r) { return s + r[1]; }, 0);
    if (discBox) {
      discBox.hidden = !off;
      discBox.innerHTML = !off ? "" :
        '<div class="cartd__drow"><span>Items</span><span>' + money(cart.original_total_price || (cart.total_price + off)) + "</span></div>" +
        rows.map(function (r) { return '<div class="cartd__drow cartd__drow--save"><span>' + esc(r[0]) + "</span><span>&minus;" + money(r[1]) + "</span></div>"; }).join("");
    }
    if (saved) { saved.hidden = !off; saved.innerHTML = off ? "You're saving <b>" + money(off) + "</b>" : ""; }
  }
  function fetchCart() {
    return fetch(cfg.routes.cart + ".js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }
  function changeLine(key, qty, lineEl) {
    if (lineEl) lineEl.classList.add("is-removing");
    return fetch(cfg.routes.cartChange + ".js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {
      if (lineEl) lineEl.classList.remove("is-removing");
    });
  }
  if (cartDrawer) {
    cartDrawer.addEventListener("click", function (e) {
      var line = e.target.closest("[data-key]");
      if (!line) return;
      var key = line.getAttribute("data-key");
      var qtyEl = $(".cartd__qty span", line);
      var q = parseInt(qtyEl && qtyEl.textContent, 10) || 1;
      var step = e.target.closest("[data-qty-change]");
      if (step) { changeLine(key, Math.max(0, q + parseInt(step.getAttribute("data-qty-change"), 10)), line); }
      else if (e.target.closest("[data-remove]")) { changeLine(key, 0, line); }
    });
    /* The header cart opens the drawer; the link still works without JS. */
    $$("[data-cart-toggle]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (document.body.classList.contains("template-cart")) return;
        e.preventDefault();
        openDrawer("cart");
        fetchCart().then(renderCart);
      });
    });
    /* Fill the drawer on load so the first open is instant. */
    if (($("[data-cart-count]") || {}).textContent !== "0") fetchCart().then(renderCart).catch(function () {});
  }

  /* Every add-to-cart form -- product page, sticky bar, quick-add on cards --
     goes over the AJAX API and opens the drawer instead of navigating away.
     Buy-it-now and the wallet buttons are untouched. */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !cartDrawer || !window.fetch) return;
    var btn = e.submitter || $('[type="submit"]', form);
    if (btn && btn.disabled) return;
    e.preventDefault();
    var fd = new FormData(form);
    if (!fd.get("quantity")) fd.set("quantity", "1");
    var label = btn ? btn.innerHTML : "";
    if (btn) { btn.setAttribute("aria-busy", "true"); btn.disabled = true; }
    fetch(cfg.routes.cartAdd + ".js", { method: "POST", body: fd, credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw new Error(b.description || b.message || "Could not add to cart"); return b; }); })
      .then(function () {
        if (btn) {
          btn.classList.add("is-added");
          if (btn.classList.contains("pcard__btn")) btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="m5 12 5 5 9-10"/></svg><span>Added</span>';
        }
        return fetchCart();
      })
      .then(function (cart) { renderCart(cart); openDrawer("cart"); })
      .catch(function (err) {
        var msg = document.createElement("p");
        msg.className = "cartd__err"; msg.setAttribute("role", "alert"); msg.textContent = err.message;
        form.appendChild(msg);
        setTimeout(function () { msg.remove(); }, 5000);
      })
      .then(function () {
        if (!btn) return;
        btn.removeAttribute("aria-busy"); btn.disabled = false;
        setTimeout(function () { btn.classList.remove("is-added"); btn.innerHTML = label; }, 1800);
      });
  });

  /* ---------------------------------------------------- predictive search */
  (function () {
    var form = $("[data-predictive]");
    if (!form || !window.fetch) return;
    var input = $("[data-predictive-input]", form);
    var box = $("[data-predictive-results]", form);
    var ctrl = null, active = -1, lastQ = "";

    function hl(text, q) {
      var t = esc(text);
      var words = q.trim().split(/\s+/).filter(Boolean).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); });
      if (!words.length) return t;
      return t.replace(new RegExp("(" + words.join("|") + ")", "ig"), "<mark>$1</mark>");
    }
    function close() { box.hidden = true; input.setAttribute("aria-expanded", "false"); active = -1; }
    function options() { return $$(".predictive__item, .predictive__all", box); }
    function setActive(i) {
      var o = options();
      o.forEach(function (x) { x.classList.remove("is-active"); x.removeAttribute("aria-selected"); });
      active = i;
      if (o[i]) { o[i].classList.add("is-active"); o[i].setAttribute("aria-selected", "true"); o[i].scrollIntoView({ block: "nearest" }); }
    }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (q === lastQ && !box.hidden) return;
      lastQ = q;
      if (ctrl) ctrl.abort();
      ctrl = "AbortController" in window ? new AbortController() : null;
      var url = cfg.routes.predictive + ".json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag";
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var res = (d && d.resources && d.resources.results) || {};
          var prods = res.products || [], cols = res.collections || [];
          var html = "";
          if (prods.length) {
            html += '<div class="predictive__group" role="group" aria-label="Products"><p class="predictive__label">Products</p>';
            prods.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf("?") > -1 ? "&" : "?") + "width=120" : "";
              html += '<a class="predictive__item" role="option" href="' + esc(p.url) + '">' +
                (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : "<span></span>") +
                "<span>" + hl(p.title.replace(" (PRE-ORDER)", ""), q) + "</span><b>" + esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : "") + "</b></a>";
            });
            html += "</div>";
          }
          if (cols.length) {
            html += '<div class="predictive__group" role="group" aria-label="Collections"><p class="predictive__label">Shelves</p><div class="predictive__chips">';
            cols.slice(0, 6).forEach(function (c) { html += '<a class="chip" href="' + esc(c.url) + '">' + hl(c.title, q) + "</a>"; });
            html += "</div></div>";
          }
          if (!html) html = '<p class="predictive__empty">No matches for “' + esc(q) + '”. Try a set name or a character.</p>';
          html += '<a class="predictive__all" role="option" href="' + cfg.routes.search + "?q=" + encodeURIComponent(q) + '&options[prefix]=last">See all results for “' + esc(q) + '” <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
          box.innerHTML = html;
          box.hidden = false;
          box.setAttribute("role", "listbox");
          input.setAttribute("aria-expanded", "true");
          active = -1;
        })
        .catch(function () {});
    }, 180);

    input.addEventListener("input", run);
    input.addEventListener("focus", function () { if (input.value.trim().length >= 2) { lastQ = ""; run(); } });
    input.addEventListener("keydown", function (e) {
      if (box.hidden) return;
      var o = options();
      if (e.key === "ArrowDown") { e.preventDefault(); setActive(Math.min(o.length - 1, active + 1)); }
      else if (e.key === "ArrowUp") { e.preventDefault(); setActive(Math.max(-1, active - 1)); }
      else if (e.key === "Enter" && active > -1 && o[active]) { e.preventDefault(); window.location = o[active].href; }
      else if (e.key === "Escape") { close(); }
    });
    document.addEventListener("click", function (e) { if (!form.contains(e.target)) close(); });
  })();

  /* ----------------------------------------------------- product gallery */
  $$("[data-gallery]").forEach(function (g) {
    var main = $("[data-gallery-main]", g);
    $$("[data-gallery-thumb]", g).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!main) return;
        main.style.opacity = "0";
        setTimeout(function () {
          main.src = btn.dataset.full;
          main.alt = btn.dataset.alt || main.alt;
          main.style.opacity = "1";
        }, reduceMotion ? 0 : 140);
        $$("[data-gallery-thumb]", g).forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
      });
    });
    if (main) main.style.transition = "opacity 180ms ease";
  });

  /* ------------------------------------------------------ description tabs */
  $$("[data-tabs]").forEach(function (wrap) {
    $$("[data-tab]", wrap).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.dataset.tab;
        $$("[data-tab]", wrap).forEach(function (b) { b.classList.toggle("is-active", b === btn); });
        $$("[data-panel]", wrap).forEach(function (p) { p.classList.toggle("is-active", p.dataset.panel === id); });
      });
    });
  });

  /* ------------------------------------------------------ quantity steppers */
  $$("[data-qty]").forEach(function (box) {
    var input = $("input", box);
    $$("button", box).forEach(function (b) {
      b.addEventListener("click", function () {
        var step = b.dataset.step === "up" ? 1 : -1;
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + step);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* --------------------------------------------------------- variant picker
     Variant data is printed as JSON next to the form so the picker never has
     to guess an availability state the server did not send. */
  $$("[data-variants]").forEach(function (form) {
    var data;
    try { data = JSON.parse($("[data-variant-json]", form).textContent); } catch (e) { return; }
    var select = $("[data-variant-select]", form);
    var idField = $("[name=id]", form);
    var priceNow = $("[data-price-now]", form);
    var priceWas = $("[data-price-was]", form);
    var submit = $("[data-add]", form);
    if (!select) return;
    select.addEventListener("change", function () {
      var v = data.filter(function (x) { return String(x.id) === select.value; })[0];
      if (!v) return;
      idField.value = v.id;
      if (priceNow) priceNow.textContent = v.price;
      if (priceWas) { priceWas.textContent = v.compare || ""; priceWas.style.display = v.compare ? "" : "none"; }
      if (submit) { submit.disabled = !v.available; submit.textContent = v.available ? submit.dataset.label : submit.dataset.soldout; }
      if (history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set("variant", v.id);
        history.replaceState({}, "", url);
      }
    });
  });

  /* ------------------------------------------------ collection sort + filters */
  var sort = $("[data-sort]");
  if (sort) {
    sort.addEventListener("change", function () {
      var url = new URL(window.location);
      url.searchParams.set("sort_by", sort.value);
      url.searchParams.delete("page");
      window.location = url.toString();
    });
  }
  (function () {
    var facets = $("[data-facets]");
    if (!facets) return;
    var wide = window.matchMedia("(min-width: 1000px)");
    function open() { facets.classList.add("is-open"); document.documentElement.classList.add("has-drawer"); var p = $(".facets__panel", facets); if (p) p.focus(); }
    function close() { facets.classList.remove("is-open"); document.documentElement.classList.remove("has-drawer"); }
    $$("[data-facets-open]").forEach(function (b) { b.addEventListener("click", open); });
    $$("[data-facets-close]", facets).forEach(function (b) { b.addEventListener("click", close); });
    facets.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    /* On desktop a filter applies as soon as it is ticked; in the mobile
       drawer that would reload the page on every tap, so it waits for
       "Show results". */
    $$("[data-facet-form] input").forEach(function (i) {
      i.addEventListener("change", function () {
        if (!wide.matches) return;
        if (i.type === "number") return;
        i.form.submit();
      });
    });
    $$("[data-facet-form] input[type=number]").forEach(function (i) {
      i.addEventListener("change", function () { if (wide.matches) i.form.submit(); });
    });
    $$("[data-facet-more]").forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".facet__more", b.parentNode).forEach(function (li) { li.hidden = false; });
        b.remove();
      });
    });
    /* Empty price inputs would send "filter.v.price.gte=" and zero the range. */
    $$("[data-facet-form]").forEach(function (f) {
      f.addEventListener("submit", function () {
        $$("input[type=number]", f).forEach(function (i) { if (i.value === "") i.disabled = true; });
      });
    });
  })();

  /* -------------------------------------------------- recommendations */
  $$("[data-recs-url]").forEach(function (sec) {
    if (!window.fetch) return;
    fetch(sec.getAttribute("data-recs-url"))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var body = doc.querySelector("[data-recs-body]");
        if (body && body.querySelector(".pcard")) {
          $("[data-recs-body]", sec).innerHTML = body.innerHTML;
          prepareGroups(sec);
        }
      })
      .catch(function () {});
  });

  /* ------------------------------------------------------- scroll reveal */
  function prepareGroups(root) {
    $$("[data-reveal-group]", root).forEach(function (g) {
      $$("[data-reveal-item]", g).forEach(function (el, i) {
        el.style.setProperty("--i", i);
        el.addEventListener("transitionend", function once(ev) {
          if (ev.propertyName !== "opacity") return;
          el.classList.add("is-settled");
          el.removeEventListener("transitionend", once);
        });
      });
    });
  }
  (function () {
    prepareGroups(document);
    if (reduceMotion || !("IntersectionObserver" in window)) return;
    /* Only what starts below the fold is hidden and animated (see the CSS). */
    var fold = window.innerHeight;
    var targets = $$("[data-reveal], [data-reveal-group]").filter(function (t) {
      return t.getBoundingClientRect().top > fold * 0.9;
    });
    targets.forEach(function (t) { t.classList.add("rv"); });
    function reveal(t) { t.classList.add("is-in"); io.unobserve(t); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) reveal(en.target); });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.01 });
    targets.forEach(function (t) { io.observe(t); });
    /* Belt and braces: after any scroll settles, reveal whatever is on screen,
       in case an observer callback was coalesced away by a fast flick. */
    var sweep = debounce(function () {
      targets.forEach(function (t) {
        if (!t.classList.contains("is-in") && t.getBoundingClientRect().top < window.innerHeight) reveal(t);
      });
    }, 120);
    window.addEventListener("scroll", sweep, { passive: true });
  })();

  /* ------------------------------------------------- tilt + hero parallax
     Pointer-driven, fine pointers only, eased with a lerp in rAF so the
     motion has weight instead of snapping to the cursor. */
  if (finePointer && !reduceMotion) {
    $$("[data-tilt]").forEach(function (el) {
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      function loop() {
        cx += (tx - cx) * 0.18; cy += (ty - cy) * 0.18;
        el.style.setProperty("--rx", cy.toFixed(2) + "deg");
        el.style.setProperty("--ry", cx.toFixed(2) + "deg");
        if (Math.abs(tx - cx) > 0.01 || Math.abs(ty - cy) > 0.01) raf = requestAnimationFrame(loop); else raf = null;
      }
      el.addEventListener("pointermove", function (e) {
        var r = el.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 10;
        ty = -((e.clientY - r.top) / r.height - 0.5) * 8;
        el.classList.add("is-tilting");
        if (!raf) raf = requestAnimationFrame(loop);
      });
      el.addEventListener("pointerleave", function () {
        tx = 0; ty = 0; el.classList.remove("is-tilting");
        if (!raf) raf = requestAnimationFrame(loop);
      });
    });
    var hero = $("[data-hero]"), stack = $("[data-hero-stack]");
    if (hero && stack) {
      var px = 0, py = 0, cpx = 0, cpy = 0, hraf = null;
      function hloop() {
        cpx += (px - cpx) * 0.08; cpy += (py - cpy) * 0.08;
        stack.style.setProperty("--px", cpx.toFixed(3));
        stack.style.setProperty("--py", cpy.toFixed(3));
        if (Math.abs(px - cpx) > 0.001 || Math.abs(py - cpy) > 0.001) hraf = requestAnimationFrame(hloop); else hraf = null;
      }
      hero.addEventListener("pointermove", function (e) {
        var r = hero.getBoundingClientRect();
        px = ((e.clientX - r.left) / r.width - 0.5) * 2;
        py = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!hraf) hraf = requestAnimationFrame(hloop);
      });
      hero.addEventListener("pointerleave", function () { px = 0; py = 0; if (!hraf) hraf = requestAnimationFrame(hloop); });
    }
  }
})();
